import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import {Provider} from 'react-redux';
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';
import smoothscroll from 'smoothscroll-polyfill';
import { getRatesFromCSV } from './utils/csv';
import {
    LOAN_RATE,
    LOAN_RATE_UNDER_30,
    LOAN_RATE_GREEN_VEHICLE
  } from './resources/constants/rates';

//  Fallback to standard rates in case CSV file is not available
window.LOAN_RATE = LOAN_RATE;
window.LOAN_RATE_UNDER_30 = LOAN_RATE_UNDER_30;
window.LOAN_RATE_GREEN_VEHICLE = LOAN_RATE_GREEN_VEHICLE;

// Get rates from CSV hosted in SharePoint
getRatesFromCSV();

// kick off the polyfill!
smoothscroll.polyfill();

if (!global.Intl) {
    global.Intl = require('intl');
    require('intl/locale-data/jsonp/de');
    require('intl/locale-data/jsonp/fr');
    require('intl/locale-data/jsonp/en');
}

const AppWithProvider = () => (
    <Provider store={store}>
        <App />
    </Provider>
);

ReactGA.initialize('G-SLVJS4XTS6');
ReactDOM.render(<AppWithProvider />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
